import React from "react";
import { Grid } from "@material-ui/core";
import { RouteComponentProps, Router } from "@reach/router";
import { Mapping, Timezone } from "pages/dashboard/admin/import/interest_imports/types";
import { Viewer } from "components/auth/types";
import { Problem } from "pages/dashboard/admin/import/interest_imports/validate";
import StepUpload from "./steps/step-0-upload";
import StepOrganize from "./steps/step-1-organize";
import StepMatch from "./steps/step-2-match";
import StepValidate from "./steps/step-3-validate";
import StepErrors from "./steps/step-4-errors";
import StepFinalize from "./steps/step-5-finalize";
import StepSuccess from "./steps/step-6-success";
import StepNavigation from "./components/step-navigation";
import BreadcrumbNavigator from "./components/breadcrumb-navigator";
import { StepProvider } from "./context";

export type StepData = Record<string, any> & {
  file: File | null;
  files: File[];
  data: Record<string, any>[];
  mapping: Mapping;
  timezone: Timezone;
  validateOrder: boolean;
  problems: Problem[];
  listId?: string;
};

export type StepProps = RouteComponentProps<{}>

export const availableSteps = ["Upload", "Organize", "Match", "Validate", "Errors", "Finalize", "Confirmation"] as const;
interface Props {
  viewer: Viewer;
}

export const initialStepData: StepData = {
  file: null,
  files: [],
  data: [],
  mapping: {},
  timezone: "none",
  validateOrder: true,
  problems: [],
};

const ImportsPage: React.FC<RouteComponentProps<Props>> = ({ viewer }) => {
  if (!viewer) return null;
  if (!viewer.lists) return null;
  if (!viewer.lists.length) return null;

  return (
    <div>
      <div>
        <h2>Imports</h2>
        <StepProvider viewer={viewer}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <BreadcrumbNavigator>
                <Router primary={false}>
                  <StepUpload path="/upload" />
                  <StepOrganize path="/organize" />
                  <StepMatch path="/match" />
                  <StepValidate path="/validate" />
                  <StepErrors path="/errors" />
                  <StepFinalize path="/finalize" />
                  <StepSuccess path="/success" />
                </Router>
              </BreadcrumbNavigator>
            </Grid>
            <StepNavigation />
          </Grid>
        </StepProvider>
      </div>
    </div>
  );
};

export default ImportsPage;
